import type { HttpClient } from '@/lib/http/client.js'
import type { ShopifyFunction, ShopifyFunctionDetail, UpdateShopifyFunctionInput } from '@/types/shopify-function/shopify-function.type.js'

/** `admin/shopify-functions`, verified against `shopify-function-admin.controller.ts`. Integer ids. */
export interface ShopifyFunctionService {
  list: () => Promise<readonly ShopifyFunction[]>
  get: (id: number) => Promise<ShopifyFunctionDetail>
  update: (id: number, input: UpdateShopifyFunctionInput) => Promise<ShopifyFunctionDetail>
  /**
   * HIGH RISK (`shopify-function-activate`): points the slug at a different deployed Function.
   * A version that expects a payload the shops do not carry makes discounts SILENTLY stop.
   */
  rebind: (id: number, shopifyFunctionId: string) => Promise<ShopifyFunctionDetail>
  /** 204. Refused for a slug the code looks up by name. */
  remove: (id: number) => Promise<void>
}

export function createShopifyFunctionService(http: HttpClient): ShopifyFunctionService {
  return {
    list: () => http.get<readonly ShopifyFunction[]>('admin/shopify-functions'),
    get: (id) => http.get<ShopifyFunctionDetail>(`admin/shopify-functions/${String(id)}`),
    update: (id, input) => http.patch<ShopifyFunctionDetail>(`admin/shopify-functions/${String(id)}`, input),
    rebind: (id, shopifyFunctionId) =>
      http.put<ShopifyFunctionDetail>(`admin/shopify-functions/${String(id)}/binding`, { shopify_function_id: shopifyFunctionId }),
    remove: async (id) => {
      await http.delete(`admin/shopify-functions/${String(id)}`)
    },
  }
}
